import Config from "../_config/config";
import myAxios from "./axiositeachWrapper";

const BASE = `${Config.nodeSiteUrl}v1/omr`;

class OmrService {
  // Templates
  listTemplates() {
    return myAxios.get<any>(`${BASE}/templates`);
  }

  createTemplate(data: any) {
    return myAxios.post<any>(`${BASE}/templates`, data);
  }

  generateSheetPdf(templateId: number | string, params?: Record<string, string>) {
    return myAxios.get<any>(`${BASE}/templates/${templateId}/generate-sheet`, {
      params,
      responseType: "blob",
    });
  }

  // Tests
  listTests() {
    return myAxios.get<any>(`${BASE}/tests`);
  }

  createTest(data: any) {
    return myAxios.post<any>(`${BASE}/tests`, data);
  }

  getTest(id: number) {
    return myAxios.get<any>(`${BASE}/tests/${id}`);
  }

  updateTest(id: number, data: any) {
    return myAxios.put<any>(`${BASE}/tests/${id}`, data);
  }

  // Answer Keys
  saveAnswerKeys(testId: number, sets: any[]) {
    return myAxios.post<any>(`${BASE}/tests/${testId}/answer-keys`, { sets });
  }

  getAnswerKeys(testId: number) {
    return myAxios.get<any>(`${BASE}/tests/${testId}/answer-keys`);
  }

  // Scans
  uploadScans(testId: number, files: File[]) {
    const formData = new FormData();
    files.forEach((f) => formData.append("scans", f));
    return myAxios.post<any>(`${BASE}/tests/${testId}/scans/upload`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  processScans(testId: number, scanIds?: number[]) {
    return myAxios.post<any>(`${BASE}/tests/${testId}/scans/process`, { scanIds });
  }

  listScans(testId: number) {
    return myAxios.get<any>(`${BASE}/tests/${testId}/scans`);
  }

  getScanDetail(testId: number, scanId: number) {
    return myAxios.get<any>(`${BASE}/tests/${testId}/scans/${scanId}`);
  }

  updateScan(testId: number, scanId: number, data: any) {
    return myAxios.put<any>(`${BASE}/tests/${testId}/scans/${scanId}`, data);
  }

  // Results
  getResultsPreview(testId: number) {
    return myAxios.get<any>(`${BASE}/tests/${testId}/results-preview`);
  }

  finalize(testId: number) {
    return myAxios.post<any>(`${BASE}/tests/${testId}/finalize`);
  }

  exportExcel(testId: number) {
    return myAxios.get<any>(`${BASE}/tests/${testId}/export-excel`, {
      responseType: "blob",
    });
  }

  getQuestionAnalysis(testId: number) {
    return myAxios.get<any>(`${BASE}/tests/${testId}/question-analysis`);
  }
}

export default new OmrService();
